import { ApiFetchType } from '@/server/api-fetch';

export type InterestRatesType = {
    sparkonto_privat: string | null;
    fastrantekonto_privat: string | null;
    sparkonto_foretag: string | null;
    sparkonto_trygg: string | null;
    fastrantekonto_foretag: string | null;
    sparkonto_foretagarna: string | null;
};

export type GeneralSettingsApiResponse = {
    humany_settings: {
        humany_base_url: string | null;
        humany_client_id: string | null;
        humany_page_link: string | null;
        humany_page_link_business: string | null;
        humany_ai_chatbot_widget_name: string | null;
        humany_enable_search_results: boolean | null;
        humany_global_chatbot_enable: boolean | null;
        humany_global_chatbot_text: string | null;
        humany_search_api: string | null;
        humany_search_api_business?: string | null;
        humany_enable_search_results_business?: boolean | null;
    };
    mfn_single_page_link: string | null;
    mfn_landing_page_link?: string | null;
    consumerloan_version: string;
    external_modules_version: string;
    cookie_read_more_page: string | null;
    show_floating_cookie: boolean | null;
    schema_fields?: {
        phone: string;
        email: string;
        street_address: string;
        locality: string;
        post_code: string;
        founding_date: string;
        social_links: {
            url: string;
        }[];
    } | null;
    interest_rates: InterestRatesType | null;
};

export const GENERAL_SETTINGS_QUERY_KEY = 'general-settings';

export const getGeneralSettings = (context: ApiFetchType) =>
    context.fetch ? context.fetch<GeneralSettingsApiResponse>('api/general/general') : null;
